import React, { useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { DEFAULT_CURRENCY_CODE } from 'lib/core/resources/constants'
import { Price } from 'lib/shared/components'
import { Button, Spinner } from 'lib/ui/components'
import { Arrow, BottomActions } from '../Styled'
import { ProductItem } from './components/ProductItem'
import { CustomerOrder } from 'lib/core/data/customer/orders/types'
import { useOrderDetail } from 'hooks/customerOrderDetails'

interface Props {
  order: CustomerOrder
}

export const Item: React.FC<Props> = ({ order }) => {
  const history = useHistory()
  const location = useLocation<{ orderId?: number }>()
  const {
    grand_total: grandTotal,
    increment_id: incrementId,
    order_items: items,
    status
  } = order
  const { loadingOrderDetail, shippingName, shippingAddress } = useOrderDetail(
    order.id
  )
  const isOrderId = location.state?.orderId === order.id
  const [isVisible, setIsVisible] = useState(!!isOrderId)

  interface StatusMap {
    [key: string]: string | undefined
  }

  const statusMap: StatusMap = {
    review_kount: 'Under Review',
    processing: 'Processing',
    fraud: 'Suspected Fraud',
    pending_payment: 'Pending Payment',
    payment_review: 'Payment Review',
    pending: 'Pending',
    holded: 'On Hold',
    complete: 'Complete',
    closed: 'Closed',
    canceled: 'Canceled'
  }

  return (
    <div tabIndex={0} className='order'>
      {loadingOrderDetail ? (
        <Spinner />
      ) : (
        <div
          className='order__heading'
          onClick={() => setIsVisible(!isVisible)}
        >
          <div className='order__group'>
            <div className='order__info'>
              <strong>Order #</strong>
              <span>{incrementId}</span>
            </div>
            <div className='order__info'>
              <strong>Ship to</strong>
              <span>{shippingName}</span>
              {isVisible && <p>{shippingAddress}</p>}
            </div>
          </div>
          <div className='order__group'>
            <div className='order__info'>
              <strong>Total</strong>
              <span>
                <Price value={grandTotal} currency={DEFAULT_CURRENCY_CODE} />
              </span>
            </div>
            <div className='order__info order__statusColumn'>
              <span>{statusMap[status]}</span>
            </div>
            <div className='order__arrow'>
              <Arrow
                open={isVisible}
                onKeyPress={(e: any) => e.key === 'Enter' && setIsVisible(!isVisible)}
              />
            </div>
          </div>
        </div>
      )}
      {!loadingOrderDetail &&
        isVisible &&
        items &&
        !!items.length &&
        items.map((item, index) => {
          return (
            <>
              <ProductItem key={index} item={item} />
              {status === 'complete' && (
                <BottomActions>
                  <Button onClick={() => history.push('/sales/guest/form')}>
                    Return this order
                  </Button>
                </BottomActions>
              )}
            </>
          )
        })}
    </div>
  )
}
